import { useMemo } from 'react';
import { useTicketDetailsParams } from '../hooks/useTicketDetailsParams';
import { useTicket } from '../data/useTicket';
import { useConfiguredTicketProperties } from '../data/usePortalData';
import { TicketInfoGrid } from './TicketInfo/TicketInfoGrid';
import { sortConfiguredTicketProperties } from '../utils/sortConfiguredTicketProperties';
import I18n from 'I18n';
import { CloseTicket } from './CloseTicket';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CollapsiblePanel } from './CollapsiblePanel';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function TicketInfoPanel(props) {
  const {
    ticketId
  } = useTicketDetailsParams();
  const configuredTicketProperties = useConfiguredTicketProperties();
  const ticketData = useTicket(ticketId);
  const configuredTicketPropertiesToDisplay = useMemo(() => {
    if (!configuredTicketProperties) return [];
    return sortConfiguredTicketProperties(configuredTicketProperties).filter(({
      propertyName
    }) => propertyName !== 'subject' && propertyName !== 'content');
  }, [configuredTicketProperties]);
  const titleNode = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "customer-portal-app.ticketInfoPanel.details"
  });
  const content = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(TicketInfoGrid, {
      ticketId: ticketId,
      configuredTicketProperties: configuredTicketPropertiesToDisplay,
      loading: ticketData.loading,
      error: !!ticketData.error,
      refetchTicket: ticketData.refetch
    }), /*#__PURE__*/_jsx(CloseTicket, {
      ticket: ticketData.data,
      ticketId: ticketId
    })]
  });
  if (props.isMobile) {
    return /*#__PURE__*/_jsx(CollapsiblePanel, {
      mode: "overlay",
      isOpen: props.isInfoPanelOpen,
      onClose: () => props.setIsInfoPanelOpen(false),
      align: "left",
      inlineSize: "100dvw",
      ariaCloseLabel: I18n.text('customer-portal-app.ticketInfoPanel.ariaClose'),
      title: titleNode,
      children: content
    });
  }
  return /*#__PURE__*/_jsx(CollapsiblePanel, {
    mode: "sidebar",
    borderSide: "end",
    expandAriaLabel: I18n.text('customer-portal-app.ticketInfoPanel.expand'),
    collapseAriaLabel: I18n.text('customer-portal-app.ticketInfoPanel.collapse'),
    title: titleNode,
    children: content
  });
}